import React from "react";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import { MODAL_TYPES } from "../../utils/emitter";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useFirebaseWebNotification from "../../hooks/useFirebaseWebNotification";
import useModalActions from "../../hooks/useModalActions";
import "./style.scss";
import { isWebView } from "../../utils/helpers";
import * as Sentry from "@sentry/react";

export default function PermissionModal() {
  const navigate = useNavigate();
  const { connectFirebaseWebNotification } = useFirebaseWebNotification();
  const { t } = useTranslation();
  const { closeModal } = useModalActions();

  async function requestPermission() {
    try {
      await Notification.requestPermission();
      await connectFirebaseWebNotification();
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <BaseModal
      preventClose
      containerStyle="permission_container"
      className="permission_modal little-mobile-modal"
      description={t("permissionModal.description")}
      eventTypeModal={MODAL_TYPES.PERMISSION}
      descriptionStyle="permission__desc"
    >
      <BaseButton
        className="permission__button"
        onClick={() => {
          requestPermission();
          closeModal(MODAL_TYPES.PERMISSION);
        }}
      >
        {t("permissionModal.button")}
      </BaseButton>
    </BaseModal>
  );
}
